import { render } from "./priceSummary.vue?vue&type=template&id=6fa42f4c&scoped=true&ts=true"
import script from "./priceSummary.vue?vue&type=script&lang=ts"
export * from "./priceSummary.vue?vue&type=script&lang=ts"

import "./priceSummary.vue?vue&type=style&index=0&id=6fa42f4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fa42f4c"]])

export default __exports__